// Handle unhandled promise rejections from Coralogix when blocked by ad-blockers
// This MUST be set up BEFORE any Coralogix imports to catch async errors during module load
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || String(event.reason);
  if (
    errorMessage.includes('coralogix') ||
    errorMessage.includes('cx-ingest') ||
    errorMessage.includes('NetworkError')
  ) {
    event.preventDefault();
    console.warn('Coralogix request blocked (likely by ad-blocker)');
  }
});

// Coralogix RUM must be initialized after the handler is set up
import { initCoralogixRum } from './config/rum';
initCoralogixRum();

// These must two lines be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client'; 
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import store from '@/store/store';
import './config/i18n'




const container = document.getElementById('root');
const root = createRoot(container); 
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

if ('serviceWorker' in navigator && window.isSecureContext) {
  const swPath = import.meta.env.MODE === 'production' 
    ? '/chatbot/sw.js' 
    : '/chatbot/sw-dev.js';

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const registration = await navigator.serviceWorker.register(swPath, {
        scope: '/chatbot/'
      });
      console.info('Service Worker registered successfully');
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'redundant') {
            console.warn('Service Worker became redundant');
          }
        });
      });
    } catch (error) {
      console.error('Service Worker registration failed:', {
        message: error.message,
        name: error.name,
        swPath,
        scope: '/chatbot/',
        serviceWorkerSupported: 'serviceWorker' in navigator,
        isSecureContext: window.isSecureContext,
        currentURL: window.location.href,
      });
    }
  });
}
